module.exports = __webpack_public_path__ + "img/google-safe-browsing.35dd6152.png";